<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Detail Pindah Gudang</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Pindah Barang <strong>{{ data.no_faktur }}</strong><br />
                    No. Ref <strong>{{ data.no_ref }}</strong><br />
                    Pindah Barang Dari <strong>Gudang {{ data.from }} - {{ data.from_office }}</strong><br />
                    Pindah Barang Ke <strong>Gudang {{ data.to }} - {{ data.to_office }}</strong><br />
                    Ditransaksikan oleh <strong>{{ data.confirmed_by }}</strong> pada {{ $helper.parseDate(data.confirmed_at) }}, {{ $helper.parseHourMinute(data.confirmed_at) }}<br />
                    Tanggal Perpindahan: <strong>{{ $helper.parseDate(data.move_date) }}</strong><br />
                    Divisi Barang: <strong>{{ data.division }}</strong><br />
                    Catatan Pindah Barang: {{ data.note || "-" }}
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="dark" @click="showInvoiceModal" :disabled="isShowing">
                        <i class="fa fa-print mr-2" />Cetak Faktur
                    </b-button>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Pencarian No. Faktur / IMEI SN">
                        <b-form-input v-model="filterInput" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="items"
                :fields="fields"
                :filter="filterInput"
                :filter-included-fields="['no_faktur_pgi', 'imei_sn']"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Cetak Barcode" :disabled="isShowing" @click="prepareReprint(row.item)">
                        <i class="fa fa-fw fa-print" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-reprint-code" title="Reprint Barcode" centered no-close-on-backdrop hide-footer @shown="$refs.passcode.focus()">
            <b-form-group label="Passcode Reprint">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode" @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                    {{ isSubmitting ? "Mengambil..." : "Reprint" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-reprint-faktur" title="Cetak Ulang Faktur" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="hideInvoiceModal()">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-reprint-barcode" title="Cetak Ulang Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Silahkan cetak barcode dibawah ini.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodePage == '1' ? 'Barcode tanpa harga' : 'Barcode ada harga' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="hideBarcodeModal()">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isShowing: false,

            filterInput: "",
            invoiceLink: "",
            invoiceLinkA4: "",

            barcodeLink: "",
            barcodeLinkDamage: "",

            data: {},
            items: [],

            fields: [
                { key: "no", label: "No." },
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

            barcodePage: '1',
            barcodeToggleCooldown: false,

            passcode: "",
            activeId: 0,

        }
    },

    computed: {
        isGoldDivision() {
            return this.data.division_id == 4
        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.$axios.get("move-warehouse/" + this.$route.params.id).then(res => {

                this.data = res.data.data

            })
            .catch(error => this.$helper.parseError(this, error))

            let getItems = this.getItems()

            Promise.all([getData, getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        getInvoiceLink() {
            const fullname = localStorage.getItem("fullname");
            const encodedFullname = fullname ? btoa(fullname) : '';
            if(this.invoiceSize == 'A5'){
                return `${this.$BASE_PRINT_FILE_PATH}${this.invoiceLink}-${encodedFullname}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}${this.invoiceLinkA4}-${encodedFullname}`
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

        showInvoiceModal() {
            this.invoiceLink = `/umgtimvce/${this.$route.params.id}`
            this.invoiceLinkA4 = `/umgtimva4/${this.$route.params.id}`
            this.isShowing = true
            this.$bvModal.show('m-reprint-faktur')
        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}?page=${this.barcodePage}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if(this.barcodePage == '1') this.barcodePage = '2'
            else this.barcodePage = '1'
            setTimeout(function(){
                this.barcodeToggleCooldown = false
            }.bind(this),2000);
        },

        prepareReprint(item) {
            this.activeId = item.inventory_id
            if (this.isGoldDivision) {
                this.$bvModal.show('m-reprint-code')
            } else {
                this.getReprintBarcode()
            }
        },

        getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.activeId,
                ...(this.isGoldDivision ? { passcode: this.passcode } : {})
            }

            this.$axios.post("inventory/reprint-barcode-move", payload).then(res => {

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.isShowing = true
                this.$bvModal.hide('m-reprint-code')
                this.$bvModal.show('m-reprint-barcode')
                this.passcode = ""


            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        hideInvoiceModal() {
            this.isShowing = false
            this.$bvModal.hide('m-reprint-faktur')
        },

        hideBarcodeModal() {
            this.isShowing = false
            this.$bvModal.hide('m-reprint-barcode')
        },

        getItems(page){
            this.isBusy = true

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("move-warehouse/detail/" + this.$route.params.id + param).then(res => {
                this.items = res.data.data.items.map(item => {
                    return {
                        id: item.id,
                        type: item.type,
                        brand: item.brand,
                        kind: item.kind,
                        year: item.year,
                        no_faktur_pgi: item.no_faktur,
                        imei_sn: item.no_faktur_string,
                        inventory_id: item.inventory_id
                    }
                })
                this.totalRows = res.data.data.total
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isBusy = false })
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        }

    },
    created() {
        this.init()
    }
}
</script>

<style>

</style>
